export const NOTIFICATION_FREQUENCY = [
  {
    value: 1,
    label: 'Hourly',
  },
  {
    value: 2,
    label: 'Daily',
  },
  {
    value: 3,
    label: 'Weekly',
  },
  {
    value: 4,
    label: 'Monthly',
  },
  {
    value: 5,
    label: 'Quarterly',
  },
  {
    value: 6,
    label: 'Yearly',
  },
];

export const NOTIFICATION_TYPE = [
  {
    value: 1,
    label: 'Change Notification',
  },
  {
    value: 2,
    label: 'SAR Notification',
  },
  {
    value: 3,
    label: 'Background Check Notification',
  },
  {
    value: 6,
    label: 'Account Processing Check Notification',
  },
];

export const NOTIFICATION_FREQUENCY_OBJECT = {
  1: 'Hourly',
  2: 'Daily',
  3: 'Weekly',
  4: 'Monthly',
  5: 'Quarterly',
  6: 'Yearly',
};

export const NOTIFICATION_TYPE_OBJECT = {
  1: 'Change Notification',
  2: 'SAR Notification',
  3: 'Background Check Notification',
  6: 'Account Processing Check Notification',
};

export const STATES = [
  {
    value: '',
    label: '',
  },
  {
    value: 'AL',
    label: 'Alabama',
  },
  {
    value: 'AK',
    label: 'Alaska',
  },
  {
    value: 'AZ',
    label: 'Arizona',
  },
  {
    value: 'AR',
    label: 'Arkansas',
  },
  {
    value: 'CA',
    label: 'California',
  },
  {
    value: 'CO',
    label: 'Colorado',
  },
  {
    value: 'CT',
    label: 'Connecticut',
  },
  {
    value: 'DE',
    label: 'Delaware',
  },
  {
    value: 'FL',
    label: 'Florida',
  },
  {
    value: 'GA',
    label: 'Georgia',
  },
  {
    value: 'HI',
    label: 'Hawaii',
  },
  {
    value: 'ID',
    label: 'Idaho',
  },
  {
    value: 'IL',
    label: 'Illinois',
  },
  {
    value: 'IN',
    label: 'Indiana',
  },
  {
    value: 'IA',
    label: 'Iowa',
  },
  {
    value: 'KS',
    label: 'Kansas',
  },
  {
    value: 'KY',
    label: 'Kentucky',
  },
  {
    value: 'LA',
    label: 'Louisiana',
  },
  {
    value: 'ME',
    label: 'Maine',
  },
  {
    value: 'MD',
    label: 'Maryland',
  },
  {
    value: 'MA',
    label: 'Massachusetts',
  },
  {
    value: 'MI',
    label: 'Michigan',
  },
  {
    value: 'MN',
    label: 'Minnesota',
  },
  {
    value: 'MS',
    label: 'Mississippi',
  },
  {
    value: 'MO',
    label: 'Missouri',
  },
  {
    value: 'MT',
    label: 'Montana',
  },
  {
    value: 'NE',
    label: 'Nebraska',
  },
  {
    value: 'NV',
    label: 'Nevada',
  },
  {
    value: 'NH',
    label: 'New Hampshire',
  },
  {
    value: 'NJ',
    label: 'New Jersey',
  },
  {
    value: 'NM',
    label: 'New Mexico',
  },
  {
    value: 'NY',
    label: 'New York',
  },
  {
    value: 'NC',
    label: 'North Carolina',
  },
  {
    value: 'ND',
    label: 'North Dakota',
  },
  {
    value: 'OH',
    label: 'Ohio',
  },
  {
    value: 'OK',
    label: 'Oklahoma',
  },
  {
    value: 'OR',
    label: 'Oregon',
  },
  {
    value: 'PA',
    label: 'Pennsylvannia',
  },
  {
    value: 'RI',
    label: 'Rhode Island',
  },
  {
    value: 'SC',
    label: 'South Carolina',
  },
  {
    value: 'SD',
    label: 'South Dakota',
  },
  {
    value: 'TN',
    label: 'Tennessee',
  },
  {
    value: 'TX',
    label: 'Texas',
  },
  {
    value: 'UT',
    label: 'Utah',
  },
  {
    value: 'VT',
    label: 'Vermont',
  },
  {
    value: 'VA',
    label: 'Virgina',
  },
  {
    value: 'WA',
    label: 'Washington',
  },
  {
    value: 'WV',
    label: 'West Virgina',
  },
  {
    value: 'WI',
    label: 'Wisconsin',
  },
  {
    value: 'WY',
    label: 'Wyoming',
  },
];

export const COMPLIANCE_TASK_FREQUENCY = [
  {
    value: 0,
    label: 'Daily',
  },
  {
    value: 1,
    label: 'Weekly',
  },
  {
    value: 2,
    label: 'Monthly',
  },
];

export const COMPLIANCE_TASK_TYPE = {
  Gratuity: 'Gratuity',
  License: 'License',
  Background: 'Background',
  Business: 'Business License',
  Web: 'Web Media',
  Document: 'Document',
  Processing: 'Processing',
  Sar: 'Sar',
  Change: 'Change',
};

export const SETTINGS_TAB_INDICES_PRIMARY = {
  // Compliance: 'Compliance',
  FI: 'FI Information',
  // Notifications: 'Notifications',
};

export const SETTINGS_TAB_INDICES_FI = {
  Notifications: 'Task Notifications',
};

export const COMPLIANCE_ALERT_FREQUENCY = [
  {
    value: 0,
    label: 'Daily',
  },
  {
    value: 1,
    label: 'Weekly',
  },
];
